import React, { useCallback } from 'react';
import {t} from '@lingui/macro';
import {getOptions, SelectHelper} from "./utils/helper";
import {ReadOnlySupport} from "./utils/ReadOnlySupport";
import {AutoComplete as AntAutoComplete} from "antd";
import {ReadOnlyBox} from "./utils/ReadOnlyBox";

function AutoCompleteReadOnly(props) {
    const { value, bordered, placeholder, className, disabled } = props;
    const { options, children } = props;

    function getLabel(value) {
        const newOptions = getOptions(options, children) || [];
        return newOptions.find(option => option.value === value)?.label || value;
    }

    if (bordered) {
        return (
            <ReadOnlyBox disabled={disabled} placeholder={placeholder}>
                { getLabel(value) }
            </ReadOnlyBox>
        );
    }
    return getLabel(value) || (
        <div className={`ant-custom-readonly ${className}`}>
            <span className="placeholder">{placeholder || t`No Data`}</span>
        </div>
    );
}

AutoCompleteReadOnly.defaultProps = {
    bordered: true,
};

export const AutoComplete = React.forwardRef((props, ref) => {
    const { children, popupContainerId, ...restProps } = props;

    const whenReadOnly = useCallback(() => <AutoCompleteReadOnly {...props} />, [props]);

    const notReadOnly = useCallback(() => (
        <AntAutoComplete
            {...restProps}
            ref={ref}
            getPopupContainer={SelectHelper.getPopupContainer(popupContainerId)}
        >
            {children}
        </AntAutoComplete>
    ), [children, popupContainerId, ref, restProps]);

    return <ReadOnlySupport
        {...props}
        whenReadOnly={whenReadOnly}
        notReadOnly={notReadOnly}
    />;
});

AutoComplete.Option = AntAutoComplete.Option;
AutoComplete.OptGroup = AntAutoComplete.OptGroup;
